export enum IEthnicity {
  INDIAN_NATIVE = 'American Indian / Alaskan Native',
  ASIAN_PI = ' Asian / Pacific Islander',
  AFRO_AMER = 'Black / African American',
  INDIGENOUS_INUIT = 'Indigenous / Inuit',
  HISP = 'Hispanic',
  MID_EAST = 'Middle Eastern',
  EUROPEAN = 'White / Caucasian',
  NO_ANSWER = 'Prefer not to answer',
}
export default IEthnicity;
